// @flow

import React, { useCallback } from "react";
import styled from "styled-components";
import { hiDPI } from "polished";

import { __ } from "../../lib/translate";
import { copyTextToClipboard } from "../../lib/utils";
import { LinkWrapper, LinkInput, CopyLink } from "./styledComponents";

const FileRequestModalHeader = ({ linkUrl, linkName = "" }) => {
  const copyLink = useCallback(() => {
    copyTextToClipboard(linkUrl, __("Link copied."));
  }, [linkUrl]);

  const onSocialClick = type => {
    if (type === "fb") {
      window.open(
        "http://facebook.com/sharer.php?u=" + encodeURIComponent(linkUrl),
        "facebook-share-dialog",
        "width=626,height=436"
      );
    } else if (type === "tw") {
      window.open(
        "https://twitter.com/intent/tweet?url=" + encodeURIComponent(linkUrl) + "&text=pCloud",
        "twitter-share",
        "width=550,height=450"
      );
    }
  };

  return (
    <HeaderWrapper>
      <LinkName>{linkName}</LinkName>
      <Section>
        <LinkWrapper>
          <LinkInput defaultValue={linkUrl} disabled />
          <CopyLink onClick={copyLink}>{__("shared_links_settings_copy_link")}</CopyLink>
        </LinkWrapper>
        <ShareButtons>
          <TwitterShare onClick={() => onSocialClick("tw")} />
          <FacebookShare onClick={() => onSocialClick("fb")} />
        </ShareButtons>
      </Section>
    </HeaderWrapper>
  );
};

export default FileRequestModalHeader;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 26px 20px 20px 20px;
  box-sizing: border-box;
`;

const Section = styled.div`
  display: flex;
  margin-top: 25px;
`;

const LinkName = styled.div`
  width: 90%;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  color: #000000;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const ShareButtons = styled.div`
  flex-shrink: 0;
  height: 36px;
`;

const EmailShare = styled.div`
  display: inline-block;
  margin-left: 6px;
  width: 36px;
  height: 36px;
  border-radius: 3.1px;
  cursor: pointer;

  background-color: #17bed0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 18px 14px;

  background-image: url(${require("../../../root/img/share-icons/mail.png")});
  ${hiDPI(1.5)} {
    background-image: url(${require("../../../root/img/share-icons/mail@2x.png")});
  }
`;

const TwitterShare = styled(EmailShare)`
  background-color: #1ca0f1;
  background-size: 19px 16px;

  background-image: url(${require("../../../root/img/share-icons/tw.png")});
  ${hiDPI(1.5)} {
    background-image: url(${require("../../../root/img/share-icons/tw@2x.png")});
  }
`;

const FacebookShare = styled(EmailShare)`
  background-color: #1776f1;
  background-size: 10px 19px;

  background-image: url(${require("../../../root/img/share-icons/fb.png")});
  ${hiDPI(1.5)} {
    background-image: url(${require("../../../root/img/share-icons/fb@2x.png")});
  }
`;
